import React, { useEffect, useState } from "react";
import ShortCodesListByPartner from "./_ShortCodesListByPartner";
import EditShortCodeService from "./_EditShortCodeService";
import { ApiEndpoint } from "../../utils/ApiEndpoint";
import { useAuth } from "../../Context/AuthContext";
import { httpClient } from "../../utils/HttpClient";
import PropTypes from "prop-types";

const URI = ApiEndpoint + "administration/shortcodesbypartner/";
const ShortCodesByCustomer = ({ uidPartner }) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [shortCodes, setShortCodes] = useState(null);
  const refreshData = () => {
    getShortCodes();
  };

  const getShortCodes = () => {
    httpClient("GET", URI + uidPartner, {}, userData.token).then((response) => {
      setShortCodes(response.data);
    });
  };

  useEffect(() => {
    getShortCodes();
  }, []);
  return (
    <div className="space-y-2">
      {shortCodes && (
        <ShortCodesListByPartner
          shortCodes={shortCodes}
        ></ShortCodesListByPartner>
      )}

      <EditShortCodeService
        refreshData={refreshData}
        uidPartner={uidPartner}
      ></EditShortCodeService>
    </div>
  );
};
ShortCodesByCustomer.propTypes = {
  uidPartner: PropTypes.number,
};
export default ShortCodesByCustomer;
